import React from 'react';

import { cn } from '@/lib/utils';

interface CircularProgressProps extends React.SVGAttributes<SVGSVGElement> {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  'aria-label': string;
}

const sizeMap = {
  xs: 'w-4 h-4',
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-10 h-10',
  xl: 'w-12 h-12',
};

export const CircularProgress = React.forwardRef<
  SVGSVGElement,
  CircularProgressProps
>(({ size = 'md', 'aria-label': ariaLabel, className, ...props }, ref) => {
  return (
    <div
      role="progressbar"
      aria-label={ariaLabel}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <svg
        className={cn('animate-spin', sizeMap[size], className)}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        ref={ref}
        {...props}
      >
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10"
          strokeDasharray={60}
          strokeDashoffset={30}
        />
      </svg>
    </div>
  );
});

CircularProgress.displayName = 'CircularProgress';
